// Cloud Compute (OpenNebula / Techev Cloud) self-serve activation constants.
// Provider name drives the catalog look-up in ComputeActivateLanding, which
// POSTs /api/v3/services with the resolved provider id.

/** Provider codename that backs a first-time Cloud Compute activation (OpenNebula). */
export const COMPUTE_PROVIDER = 'panda';

/** Route to a Compute service console. */
export function computeConsoleRoute(serviceId: string): string {
  return `/services/compute/${serviceId}`;
}

/** Card metadata for the Cloud Compute product (activation dialog copy). */
export const COMPUTE_PRODUCT = {
  displayName: 'Cloud Compute',
  /** Full product name used as the created service's name on self-serve activation. */
  serviceName: 'Cloud Compute',
  description:
    'Cloud Compute — provision virtual machines with networking, load balancers and backups on the Techev Cloud platform.',
  features: ['VMs', 'Networking', 'Load Balancers', 'Snapshots'],
} as const;
